import { render, staticRenderFns } from "./VenueCalendar.vue?vue&type=template&id=293115bc"
import script from "./VenueCalendar.vue?vue&type=script&lang=ts"
export * from "./VenueCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports